export const BRAND = {
  name: "Signature Spoon",
  city: "Pune & Karad",
  // instagramHandle: "@signaturespoon",
  // instagramUrl: "https://instagram.com/signaturespoon",
  whatsappNumber: "917276362030",
  fssaiNumber: "21526082005168",
  pdfMenuUrl: process.env.REACT_APP_MENU_PDF_URL || "/menu.pdf",
  googleSheetId: process.env.REACT_APP_GOOGLE_SHEET_ID || "1mQfmNuxfIsCaqm9o6eDsK1gVrkIEebGA3aotH_x4V40",
};

const defaultMsg = encodeURIComponent(
  "Hi, I would like to place an order."
);

export const waLink = (msg) =>
  `https://wa.me/${BRAND.whatsappNumber}?text=${msg ? encodeURIComponent(msg) : defaultMsg}`;

export const IMG = {
  hero: {
    a: "/assets/hero-primary.webp",
    aSm: "/assets/hero-primary-sm.webp",
    b: "/assets/hero-secondary.webp",
    bSm: "/assets/hero-secondary-sm.webp",
    c: "/assets/hero-tertiary.webp",
    cSm: "/assets/hero-tertiary-sm.webp",
  },
  story: {
    kitchen: "https://images.pexels.com/photos/6996250/pexels-photo-6996250.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    hands: "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1200&q=80",
  },
  cats: {
    butterCake: "/assets/butter-cake.webp",
    butterCake2: "/assets/butter-cake-2.webp",
    tins: "/assets/cookie-tin.webp",
    cookies: "/assets/cookies.webp",
    nankatai: "/assets/nankatai.webp",
    premix: "/assets/sambhar-premix.webp",
    cookieBar: "/assets/cookie-bar.webp",
    brownieBites: "/assets/brownie-bites.webp",
  },
};

export const NAV_LINKS = [
  { label: "Menu", href: "#categories" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Our Story", href: "#story" },
  { label: "Custom & Gifting", href: "#gifting" },
  { label: "Reviews", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];
